import { keycloak, refreshKeycloakToken } from './keycloak';
import type { KeycloakTokenParsed } from './types';

export type TokenUpdate = {
  token: string;
  refreshToken: string;
  tokenExpiry: number;
};

export interface TokenManagerCallbacks {
  onTokenUpdate: (update: TokenUpdate) => void;
  onRefreshFailure: (error: unknown) => void;
}

/**
 * Attach Keycloak token lifecycle handlers.
 *
 * We refresh the token when Keycloak reports expiration.
 */
export const attachKeycloakTokenHandlers = ({ onTokenUpdate, onRefreshFailure }: TokenManagerCallbacks) => {
  keycloak.onTokenExpired = async () => {
    try {
      const result = await refreshKeycloakToken(30);

      if (!result.token || !result.refreshToken) {
        onRefreshFailure(new Error('Missing token(s) after refresh'));
        return;
      }

      const tokenParsed = (result.tokenParsed ?? {}) as KeycloakTokenParsed;
      const tokenExpiry = typeof tokenParsed.exp === 'number' ? tokenParsed.exp * 1000 : Date.now() + 60_000;

      onTokenUpdate({
        token: result.token,
        refreshToken: result.refreshToken,
        tokenExpiry,
      });
    } catch (error) {
      onRefreshFailure(error);
    }
  };
};

